import { EPlatform } from '@cian/webview/shared';
import { useContext, useMemo } from 'react';
import { ApplicationContext } from './applicationContext';

export function useGetPlatform() {
  const { config } = useContext(ApplicationContext);

  const result = useMemo<EPlatform | null>(() => config.get<EPlatform | null>('web.platform') ?? null, [config]);

  return result;
}
